import React, { SyntheticEvent } from 'react';
import { FormControl, Button as MuiButton, styled } from '@mui/material';

const ButtonWrapper = styled(MuiButton)(
    ({ theme }) => ({
        marginRight: `-${theme.spacing(1)}`,
        width: '100%',
        margin: '10px 0 0',
        borderRadius: 8,
        '&.cancel': {
            borderColor:'#EAE9E9',
            backgroundColor: '#fffff',
            color:'#5D5A5A'
        }
    })
);

interface IButtonProps {
    label: string;
    size?: 'small' | 'medium' | 'large';
    variant?: 'text' | 'outlined' | 'contained';
    type?: 'submit' | 'reset' | 'button' | undefined;
    btnFor?: 'save' | 'submit' | 'cancel' | '' | undefined
    onClick?: (event: SyntheticEvent) => void;
}

const Button = ({
    label,
    size = 'large',
    variant = 'contained',
    type = 'button',
    btnFor = '',
    onClick = () => null
}: IButtonProps) => {
    return (
        <FormControl
            variant="outlined"
            fullWidth
            sx={{
                margin: '0 0 16px'
            }}
        >
            <ButtonWrapper size={size} variant={variant} type={type} onClick={onClick} className={`${btnFor}`}>
                {label}
            </ButtonWrapper>
        </FormControl>
    );
};

export default Button;
